module.exports = __webpack_public_path__ + "static/media/BAckmovil@2x.0951064a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/BAckmovil@2x.png
// module id = 63
// module chunks = 0